import { render } from "./audios.vue?vue&type=template&id=7be8e2e0"
import script from "./audios.vue?vue&type=script&lang=js"
export * from "./audios.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__